(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["konbini-bundle-cart"] && !Shopify.designMode) return;
  try {
    (() => {
    function metadata(item) {
      try {
        const data = JSON.parse(item.properties?.__kaching_bundles || 'null');
        return data && typeof data.id === 'string' && data.id && typeof data.v === 'string' && data.v && typeof data.deal === 'string' && data.deal ? data : null;
      } catch { return null; }
    }

    function groupBundles(items) {
      const candidates = new Map();
      items.forEach((item, index) => {
        const meta = metadata(item);
        if (!meta) return;
        const key = JSON.stringify([meta.deal, meta.v, meta.id]);
        if (!candidates.has(key)) candidates.set(key, { key, items: [], indices: [], main: null });
        const group = candidates.get(key);
        group.items.push(item);
        group.indices.push(index);
        if (meta.main) group.main = item;
      });
      return Array.from(candidates.values()).flatMap(group => {
        if (!group.main) return [];
        const titles = group.items.flatMap(item => (item.discounts || []).map(discount => discount.title));
        const size = titles.includes('Complete Your Collection') ? 3 : titles.includes('Pick Any Two') ? 2 : 0;
        if (!size) return [];
        const count = group.items.reduce((sum, item) => sum + item.quantity, 0);
        if (!count || count % size !== 0) return [];
        const quantity = count / size;
        if (!group.items.every(item => Number.isInteger(item.quantity / quantity))) return [];
        return [{ ...group, size, count, quantity, price: group.items.reduce((sum, item) => sum + item.final_line_price, 0) }];
      });
    }

    const giftImage = 'https://cdn.shopify.com/s/files/1/0977/5081/0945/files/no_text_above_keep_design_plea_Nano_Banana_2_06968_300x300.png?v=1788475561';
    const tag = (name, className, text) => {
      const node = document.createElement(name);
      if (className) node.className = className;
      if (text !== undefined) node.textContent = text;
      return node;
    };

    class KonbiniBundleCart extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        try {
          this.items = JSON.parse(this.dataset.items || '[]');
          this.form = this.closest('[data-cart-form]');
          if (!this.form) return;
          const rows = Array.from(this.form.querySelectorAll('[data-cart-item]'));
          if (rows.length !== this.items.length) return;
          this.groups = groupBundles(this.items);
          this.groups.forEach(group => {
            const card = this.card(group);
            rows[group.indices[0]].before(card);
            group.indices.forEach(index => rows[index].classList.add('kb-cart-native-hidden'));
          });
          if (this.groups.length) this.form.querySelector('.cart__line-item-header')?.classList.add('kb-cart-native-hidden');
          this.reopen();
        } catch { this.initialized = false; }
      }

      money(cents) {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: this.dataset.currency || 'USD' }).format(cents / 100);
      }

      card(group) {
        const title = group.size === 3 ? this.dataset.trio : this.dataset.pair;
        const card = tag('section', 'kb-cart-card');
        card.setAttribute('aria-label', title);
        const head = tag('div', 'kb-cart-head');
        const heading = tag('div');
        heading.append(tag('h3', '', title));
        heading.append(tag('p', '', `${group.count} ${this.dataset.magnets}${group.size === 3 ? ` · ${group.quantity} ${this.dataset.gift}` : ''}`));
        const price = tag('strong', 'kb-cart-price', this.money(group.price));
        price.setAttribute('aria-label', `${this.dataset.total} ${this.money(group.price)}`);
        head.append(heading, price);
        const list = tag('ul', 'kb-cart-list');
        const products = new Map();
        group.items.forEach(item => {
          const key = `${item.variant_id || item.id}:${item.selling_plan_allocation?.selling_plan?.id || ''}`;
          if (products.has(key)) products.get(key).quantity += item.quantity;
          else products.set(key, { ...item });
        });
        products.forEach(item => {
          const row = tag('li', 'kb-cart-product');
          const image = tag('img');
          const source = item.featured_image?.url || item.image;
          if (typeof source === 'string') image.src = source;
          image.alt = '';
          image.width = 54;
          image.height = 54;
          const label = tag('a', '', item.product_title || item.title);
          label.href = item.url;
          if (item.variant_title && item.variant_title !== 'Default Title') label.append(tag('small', '', item.variant_title));
          row.append(image, label, tag('span', 'kb-cart-product-qty', `× ${item.quantity}`));
          list.append(row);
        });
        if (group.size === 3) {
          const row = tag('li', 'kb-cart-product kb-cart-gift');
          const image = tag('img');
          image.src = giftImage;
          image.alt = '';
          image.width = 54;
          image.height = 54;
          const label = tag('span', '', this.dataset.gift);
          label.append(tag('small', '', this.dataset.included));
          row.append(image, label, tag('span', 'kb-cart-product-qty', `× ${group.quantity}`));
          list.append(row);
        }
        const controls = tag('div', 'kb-cart-controls');
        const stepper = tag('div', 'kb-cart-stepper');
        const minus = tag('button', '', '−');
        const plus = tag('button', '', '+');
        minus.type = plus.type = 'button';
        minus.disabled = group.quantity <= 1;
        minus.setAttribute('aria-label', `${this.dataset.decrease}: ${title}`);
        plus.setAttribute('aria-label', `${this.dataset.increase}: ${title}`);
        minus.addEventListener('click', () => this.update(group, group.quantity - 1, card));
        plus.addEventListener('click', () => this.update(group, group.quantity + 1, card));
        stepper.append(minus, tag('span', '', String(group.quantity)), plus);
        const remove = tag('button', 'kb-cart-remove', this.dataset.remove);
        remove.type = 'button';
        remove.setAttribute('aria-label', `${this.dataset.remove}: ${title}`);
        remove.addEventListener('click', () => this.update(group, 0, card));
        controls.append(tag('span', '', this.dataset.quantity), stepper, remove);
        const status = tag('p', 'kb-cart-status');
        status.setAttribute('role', 'status');
        status.setAttribute('aria-live', 'polite');
        card.append(head, list, controls, status);
        return card;
      }

      reopen() {
        if (!this.closest('[data-cart-drawer]')) return;
        try {
          if (sessionStorage.getItem('konbini-reopen-cart') !== '1') return;
          sessionStorage.removeItem('konbini-reopen-cart');
          setTimeout(() => document.querySelector('a[href="#cartDrawer"]')?.click(), 150);
        } catch {}
      }

      async update(group, quantity, card) {
        if (KonbiniBundleCart.busy || !Number.isInteger(quantity) || quantity < 0) return;
        KonbiniBundleCart.busy = true;
        const wrapper = this.closest('[data-cart-wrapper]');
        const status = card.querySelector('.kb-cart-status');
        wrapper?.classList.add('kb-cart-busy');
        const buttons = Array.from(document.querySelectorAll('.kb-cart-card button')).filter(button => !button.disabled);
        buttons.forEach(button => button.disabled = true);
        status.textContent = this.dataset.updating;
        let writing = false;
        try {
          const response = await fetch(`${this.dataset.root}cart.js`, { credentials: 'same-origin', cache: 'no-store' });
          if (!response.ok) throw new Error(this.dataset.error);
          const cart = await response.json();
          const fresh = groupBundles(cart.items).find(value => value.key === group.key);
          if (!fresh || fresh.quantity !== group.quantity || fresh.items.length !== group.items.length || !fresh.items.every(item => group.items.some(old => old.key === item.key && old.quantity === item.quantity))) throw new Error(this.dataset.stale);
          const increasing = quantity > fresh.quantity;
          const updates = {};
          fresh.items.forEach(item => updates[item.key] = item.quantity / fresh.quantity * quantity);
          const newBundleId = crypto.randomUUID();
          const items = fresh.items.map(item => ({ id: item.variant_id, quantity: item.quantity / fresh.quantity * (quantity - fresh.quantity), properties: { ...item.properties, __kaching_bundles: JSON.stringify({ ...metadata(item), id: newBundleId }) }, ...(item.selling_plan_allocation ? { selling_plan: item.selling_plan_allocation.selling_plan.id } : {}) }));
          writing = true;
          const result = await fetch(`${this.dataset.root}cart/${increasing ? 'add' : 'update'}.js`, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(increasing ? { items } : { updates }) });
          const changed = await result.json();
          if (!result.ok) throw new Error(changed.description || changed.message || this.dataset.error);
          if (this.closest('[data-cart-drawer]')) {
            try { sessionStorage.setItem('konbini-reopen-cart', '1'); } catch {}
          }
          window.location.reload();
        } catch (error) {
          status.textContent = error.message || this.dataset.error;
          if (writing) status.textContent += ` ${this.dataset.stale}`;
          buttons.forEach(button => button.disabled = false);
          wrapper?.classList.remove('kb-cart-busy');
          KonbiniBundleCart.busy = false;
        }
      }
    }
    if (!customElements.get('konbini-bundle-cart')) customElements.define('konbini-bundle-cart', KonbiniBundleCart);
  })();
  } catch(e) { console.error(e); }
})();

})();
